import { isNil } from 'common/checks'
import { isSafeUrl } from 'common/url'
import { usePostPaymentPortalSession } from 'queries/post-payment-portal-session'
import { Order } from 'types/order'

import { SecondaryButton } from 'components/common/buttons'
import { PurchasesCardConstants } from 'components/pages/purchases-page/constants'

export interface ManagePaymentCtaProps {
  order: Order

  // Passed down rather than read via useGetToken, which would require a router in tests.
  token: string | null
}

export function ManagePaymentCta({ order, token }: ManagePaymentCtaProps): JSX.Element | null {
  const { mutate, isLoading } = usePostPaymentPortalSession({
    onSuccess: (resp) => {
      if (isSafeUrl(resp.data.url)) {
        window.location.assign(resp.data.url)
      }
    },
  })

  // Eligibility is the server's call, and the transaction is what the request is keyed on.
  if (order.can_manage_payment !== true || isNil(order.last_transaction)) {
    return null
  }

  const transactionId = order.last_transaction.id

  return (
    <SecondaryButton
      text={PurchasesCardConstants.ManagePaymentButton}
      onClick={() => mutate({ transactionId, token })}
      isDisabled={isLoading}
      isLoading={isLoading}
    />
  )
}
